export { default } from './EConsentIndicator';
